/**
 * Do not edit directly
 * Generated on Thu, 06 Feb 2025 15:20:12 GMT
 */

export const primary = {
  "lightest": "--cnvs-brand-primary-lightest",
  "light": "--cnvs-brand-primary-light",
  "base": "--cnvs-brand-primary-base",
  "dark": "--cnvs-brand-primary-dark",
  "darkest": "--cnvs-brand-primary-darkest",
  "accent": "--cnvs-brand-primary-accent"
};
export const alert = {
  "lightest": "--cnvs-brand-alert-lightest",
  "light": "--cnvs-brand-alert-light",
  "base": "--cnvs-brand-alert-base",
  "dark": "--cnvs-brand-alert-dark",
  "darkest": "--cnvs-brand-alert-darkest",
  "accent": "--cnvs-brand-alert-accent"
};
export const error = {
  "lightest": "--cnvs-brand-error-lightest",
  "light": "--cnvs-brand-error-light",
  "base": "--cnvs-brand-error-base",
  "dark": "--cnvs-brand-error-dark",
  "darkest": "--cnvs-brand-error-darkest",
  "accent": "--cnvs-brand-error-accent"
};
export const success = {
  "lightest": "--cnvs-brand-success-lightest",
  "light": "--cnvs-brand-success-light",
  "base": "--cnvs-brand-success-base",
  "dark": "--cnvs-brand-success-dark",
  "darkest": "--cnvs-brand-success-darkest",
  "accent": "--cnvs-brand-success-accent"
};
export const neutral = {
  "lightest": "--cnvs-brand-neutral-lightest",
  "light": "--cnvs-brand-neutral-light",
  "base": "--cnvs-brand-neutral-base",
  "dark": "--cnvs-brand-neutral-dark",
  "darkest": "--cnvs-brand-neutral-darkest",
  "accent": "--cnvs-brand-neutral-accent"
};
export const action = {
  "lightest": "--cnvs-brand-action-lightest",
  "light": "--cnvs-brand-action-light",
  "base": "--cnvs-brand-action-base",
  "dark": "--cnvs-brand-action-dark",
  "darkest": "--cnvs-brand-action-darkest",
  "accent": "--cnvs-brand-action-accent"
};
export const common = {
  "focusOutline": "--cnvs-brand-common-focus-outline",
  "errorInner": "--cnvs-brand-common-error-inner",
  "alertInner": "--cnvs-brand-common-alert-inner"
};
export const gradient = {
  "primary": "--cnvs-brand-gradient-primary"
};
